import { render, staticRenderFns } from "./vue-perfectlooper.vue?vue&type=template&id=2b37b108&"
import script from "./vue-perfectlooper.vue?vue&type=script&lang=js&"
export * from "./vue-perfectlooper.vue?vue&type=script&lang=js&"
import style0 from "./perfectlooper.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports